import React from "react";
import { Header, Image } from "semantic-ui-react";

const CuentaHeader = () => {
  return (
    <Header as="h1" color="blue">
      <Image src="/assets/icons/ahorro.svg" size="medium" /> Mis cuentas
    </Header>
  );
};

export default CuentaHeader;
